import { FETCH_FAQ_TYPES, ADD_FAQ_TYPES, EDIT_FAQ_TYPES, DELETE_FAQ_TYPES, DESTROY_FAQ_TYPES } from "../actionTypes";

export const fetchFaqTypes = faqTypes => ({
    type: FETCH_FAQ_TYPES,
    faqTypes
});

export const addFaqTypes = faqType => ({
    type: ADD_FAQ_TYPES,
    faqType
});

export const deleteFaqTypes = id => ({
    type: DELETE_FAQ_TYPES,
    id
});

export const editFaqTypes = faqType => ({
    type: EDIT_FAQ_TYPES,
    faqType
});

export const destroyFaqTypes = key => ({
    type: DESTROY_FAQ_TYPES,
    key
})